import { isAxiosError } from "axios";
import {
  LoaderFunction,
  Navigate,
  Outlet,
  redirect,
  useRouteError,
} from "react-router-dom";

import { get } from "api";
import { queryClient } from "pages/Root";
import RootError from "pages/RootError";
import { setPromotionModalSeen } from "utils/functions";
import {
  extractPlatformStatus,
  PlatformAccessStatus,
} from "utils/platformAccessStatus";

import LoadingLayout from "./LoadingLayout";

export const authenticatedOnboardingLoader: LoaderFunction = async () => {
  try {
    const user = await queryClient.fetchQuery({
      queryKey: ["/user"],
      queryFn: () => get("/user"),
      staleTime: 0,
    });

    const platform = await queryClient.fetchQuery(["/platform/current"], () =>
      get("/platform/current").catch(() => null)
    );

    if (extractPlatformStatus(platform) === PlatformAccessStatus.Deactivated) {
      return redirect("/deactivated");
    }

    return user;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 401) {
      setPromotionModalSeen(false);
      return redirect("/signin");
    }
    throw error;
  }
};

const AuthenticatedOnboardingLayout = () => {
  return (
    <>
      <LoadingLayout />
      <div className="flex flex-auto">
        <div className="w-full">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export const AuthenticatedOnboardingLayoutError = () => {
  const error = useRouteError();

  if (isAxiosError(error) && error.response?.status === 401) {
    setPromotionModalSeen(false);
    return <Navigate to="/signin" />;
  }

  return <RootError />;
};

export default AuthenticatedOnboardingLayout;
